export default __webpack_public_path__ + "static/media/commander.6b7eb9d3.png";